export default __webpack_public_path__ + "static/media/khurshida.1e3b1134.png";